<template>
  <v-select
    v-model="filters.number"
    :items="filteredSensors"
    :disabled="filters.all || loading"
    :label="`${ $t('Sensor') }`"
    item-text="description"
    item-value="sensorNumber"
    class="dover-input"
    chips>
    <template
      slot="selection"
      slot-scope="data">
      <v-chip
        :selected="data.selected"
        :disabled="data.disabled"
        :key="data.item.sensorNumber"
        class="v-chip--select-multi "
        @input="data.parent.selectItem(data.item)">
        <v-avatar class="dover-avatar ">{{ data.item.sensorNumber }}</v-avatar>
        {{ data.item.sensorName }}
      </v-chip>
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: () => []
    },
    sensors: {
      type: Array,
      required: true,
      default: undefined
    },
    filters: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    filteredSensors: [],
    sensorTypes: []
  }),
  watch: {
    sensors: {
      handler: function (newSensors, oldSensors) {
        for (let index = 0; index < newSensors.length; index++) {
          let sensor = newSensors[index]
          if (sensor.compliance) {
            sensor.description = this.getSensorTypeDescription(sensor.sensorType) + ': ' + sensor.sensorNumber + '-' + sensor.sensorName
            this.filteredSensors.push(sensor)
          }
        }
        this.filteredSensors.sort((a, b) => ((a.sensorType.toString() + a.sensorNumber.toString()) > (b.sensorType.toString() + b.sensorNumber.toString())) ? 1 : -1)
      },
      immediate: true
    }
  },
  mounted () {
    this.sensorTypes = this.Maglink.SensorTypesBasic()
    this.sensorTypes = this.sensorTypes.concat(this.Maglink.SensorTypesPlus())
  },
  methods: {
    getSensorTypeDescription (sensorType) {
      return this.sensorTypes[sensorType].desc
    }
  }

}
</script>
